export default {
  customerapplabels: {
    name: "Customer App Labels",
    endpoint: "/v1/common/labels/customer",
    fields: ["value"],
    table: "applabels_translation"
  },
  retailapplabels: {
    name: "Retail App Labels",
    endpoint: "/v1/common/labels/retail",
    fields: ["value"],
    table: "applabels_translation"
  },
  dashboardapplabels: {
    name: "Dashboard App Labels",
    endpoint: "/v1/common/labels/dashboard",
    fields: ["value"],
    table: "applabels_translation"
  },
  mediacategories: {
    // OK
    name: "Media Categories",
    endpoint: "/v1/common/mediacategories",
    fields: ["name"],
    table: "mediacategories_translation"
  },
  mediaitems: {
    name: "Media Items",
    endpoint: "/v1/common/media",
    fields: ["name", "tags"],
    table: "media_translation"
  },
  templatetypes: {
    name: "Template Types",
    endpoint: "/v1/common/templatetypes",
    fields: ["name"],
    table: "templatetypes_translation"
  },
  filmtypes: {
    name: "Film Types",
    endpoint: "/v1/common/filmtypes",
    fields: ["name", "description"],
    table: "filmtypes_translation"
  },
  devicetypes: {
    name: "Device Types",
    endpoint: "/v1/common/devicetypes",
    fields: ["name"],
    table: "devicetypes_translation"
  },
  screenprotectortypes: {
    name: "Screen Protector Types",
    endpoint: "/v1/common/screenprotectortypes",
    fields: ["name", "description"],
    table: "screenprotectortypes_translation"
  }
};
